function findIndicesInMatrix(matrix, func) {
  let j = -1;
  const i = matrix.findIndex((row) => {
    j = row.findIndex(func);
    return j !== -1;
  });
  return { i, j };
}
export {
  findIndicesInMatrix
};
//# sourceMappingURL=index151.js.map
